import styled from 'styled-components';

export const UserButtonText = styled.span`
  ${({ theme }) => theme.font.regularH3St}
  font-weight: 600 !important;
  color: ${({ theme }) => theme.colors.petrol};
`;
